import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProductConfigurationIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_6132_322186)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M3.5 6.50391H14",
					stroke: "#001489",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M3.5 10.5039H9.5",
					stroke: "#001489",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M3.5 14.5039H7.25",
					stroke: "#001489",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.25 20.5039H2C1.60218 20.5039 1.22064 20.3452 0.93934 20.0639C0.658035 19.7826 0.5 19.4017 0.5 19.0039V2.00391C0.5 1.60608 0.658035 1.22455 0.93934 0.943246C1.22064 0.661942 1.60218 0.503906 2 0.503906H12.629C13.0265 0.503991 13.4078 0.661888 13.689 0.942906L16.561 3.81491C16.842 4.0961 16.9999 4.47736 17 4.87491V7.25391",
					stroke: "#001489",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 17.5,
					cy: 17.5039,
					r: 6,
					stroke: "#001489"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.4951 15.2539C17.4209 15.2539 17.3484 15.2319 17.2868 15.1907C17.2251 15.1495 17.177 15.0909 17.1487 15.0224C17.1203 14.9539 17.1129 14.8785 17.1273 14.8057C17.1418 14.733 17.1775 14.6662 17.23 14.6137C17.2824 14.5613 17.3492 14.5256 17.422 14.5111C17.4947 14.4966 17.5701 14.5041 17.6386 14.5325C17.7071 14.5608 17.7657 14.6089 17.8069 14.6706C17.8481 14.7322 17.8701 14.8047 17.8701 14.8789C17.8701 14.9784 17.8306 15.0737 17.7603 15.1441C17.69 15.2144 17.5946 15.2539 17.4951 15.2539Z",
					fill: "#001489",
					stroke: "#001489",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.4951 17.5039V20.5039",
					stroke: "#001489",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6132_322186",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(0 0.00390625)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgProductConfigurationIcon);
export default ForwardRef;
